<ul
  class="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-semibold px-9"
  ngbNav
  #nav="ngbNav"
  [activeId]="active()"
>
  @for (tab of tabs(); track tab) {
    <li class="nav-item" [ngbNavItem]="tab.id">
      <button
        class="nav-link text-white opacity-75 opacity-state-100 pb-4"
        ngbNavLink
        (click)="tabOpen(tab.id)"
      >
        @if (t()) {
          {{ t()!(tab.title) }}
        } @else {
          {{ tab.title | transloco }}
        }
      </button>
      <ng-template ngbNavContent>
        <ng-container
          *ngTemplateOutlet="contentMap.get(tab.id)!"
        ></ng-container>
      </ng-template>
    </li>
  }
</ul>

<div [ngbNavOutlet]="nav" class="mt-2"></div>
